<template>
  <!-- TODO: loader -->
  <router-view
    :is-loading-change-vcp="isLoading"
    @onChangeVcp="onChangeVcp"
  />

  <!-- TODO Перенести-->
  <signInV2 />
  <div
    id="modal"
    class="modal-root"
  />
</template>

<script>
import { mapActions, mapGetters, useStore } from 'vuex'
import { ref, provide, watch } from 'vue'
import 'normalize-scss/sass/normalize/_import-now.scss'
import './assets/styles/core/_layout.scss'
import './assets/styles/core/_toast.scss'
import './assets/styles/_payment-card.scss'

import signInV2 from '@/components/signInV2/index.vue'

export default {
  components: {
    signInV2,
  },
  setup () {
    const showForSuppliersModal = ref(false)
    const openForSuppliersModal = () => {
      showForSuppliersModal.value = true
    }
    const closeForSuppliersModal = () => {
      showForSuppliersModal.value = false
    }
    provide('showForSuppliersModal', showForSuppliersModal)
    provide('openForSuppliersModal', openForSuppliersModal)
    provide('closeForSuppliersModal', closeForSuppliersModal)

    const store = useStore()
    // imt
    watch(
      () => store.getters['client/isLoggedIn'],
      newVal => {
        // Отправка данных пользователя из ИМТ при логине
        // хоть заполнить имт можно только на лендосе, но лежать должно здесь т.к. данные должны посылаться при любом логине
        if (
          newVal &&
          store.getters['client/unauthorizedImtData'] &&
          Object.keys(store.getters['client/unauthorizedImtData']).length > 0
        ) {
          store
            .dispatch(
              'client/updateClientDetails',
              {
                height: store.getters['client/unauthorizedImtData'].height,
                weight: store.getters['client/unauthorizedImtData'].weight,
                birthday: store.getters['client/unauthorizedImtData'].birthday,
                lifestyleId_H:
                  store.getters['client/unauthorizedImtData'].lifestyleId_H,
                gender: store.getters['client/unauthorizedImtData'].gender,
                purposeWeight:
                  store.getters['client/unauthorizedImtData'].purposeWeight,
              },
              { root: true },
            )
            .then(() => {
              store.dispatch('client/clearUnauthorizedClientDetails', null, {
                root: true,
              })
            })
        }
      },
    )
    // /imt
  },
  data () {
    return {
      isLoading: false,
      appLoaded: false,
      perfomanceEventsSend: false,
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'client/isLoggedIn',
      vcpConfig: 'vcp/vcpConfig',
      profile: 'client/profile',
      activeCity: 'city/getActive',
      otherCityMode: 'city/isOtherCityMode',
      specificQueryParams: 'marketing/specificQueryParams',
    }),
    inviterSlug () {
      return this.specificQueryParams.invite
    },
  },
  watch: {
    isLoggedIn (newVal) {
      this.onChangeVcp()
      if (newVal) {
        this.sendLoggedInEvent()
      }
    },
    'activeCity.alias' () {
      this.reInitPromotionsAndTests()
    },
    'profile.activityStatus' () {
      this.reInitPromotionsAndTests()
    },
    otherCityMode (newVal, oldVal) {
      if (Boolean(newVal) !== Boolean(oldVal)) {
        this.reInitPromotionsAndTests()
      }
    },
    inviterSlug () {
      this.reInitPromotionsAndTests()
    },
  },
  async created () {
    await this.getCities()
    await this.checkDefaultCityCookie()
    await this.processSpecificQueryParams()
    if (this.isLoggedIn) {
      this.sendLoggedInEvent()

      try {
        await this.checkToken()
      } catch (error) {
        console.log(error?.status)
      }
    }
    await this.init()
    // TODO: вВЫяснить модет и не надо тут getVcpConfig, ведь он задается в роутере черех meta requiredVcp
    await this.getVcpConfig()
    await this.getCustomizationInfoDays()
    await this.getPackProperties()
    await this.getEfst()
    this.initializeYandexABFlags()
  },

  mounted () {
    this.addBeforeUnloadEvent()
    if (location.pathname.includes('standard/instant-order')) {
      this.setExpressDeliveryState(false)
    }

    window.aaa = this
    this.$store.dispatch('analytics/singleEvent', 'main_init', { global: true })
    // измерения скороси загрузки страницы
    if (document.readyState === 'complete') {
      this.sendSpeedMetrics()
    } else {
      window.addEventListener('load', () => {
        this.sendSpeedMetrics()
      })
      // на случай если пока ставится ивент листнер произойдет ивент
      this.sendSpeedMetrics()
    }
    // /измерения скороси загрузки страницы
    // захардхоженый ивент теста, выпилить с раскаткой нового сайта
    // TODO: разкоментить когда зальем сайт в прод
    this.sendAbTestVariation({ testName: 'gfab_newgf_new_unauthorized', variationKey: 'new-site', dimensionIndex: undefined }, { root: true })
    this.trackActiveTestsWithVariations(JSON.stringify({
      gfab_newgf_new_unauthorized: 'new-site',
    }))
  },

  beforeUnmount () {
    window.removeEventListener('beforeunload', this.sendBeforeUnloadEvent)
  },

  methods: {
    ...mapActions({
      checkToken: 'client/checkToken',
      checkDefaultCityCookie: 'city/checkDefaultCityCookie',
      getVcpConfig: 'vcp/getVcpConfig',
      getCustomizationInfoDays: 'customizationInfo/getCustomizationInfoDays',
      processSpecificQueryParams: 'marketing/processSpecificQueryParams',
      getPackProperties: 'customizationInfo/getPackProperties',
      getEfst: 'efst/getFrontSmsToken',
      initializeTests: 'abtesting/initializeTests',
      initializeYandexABFlags: 'abtesting/initializeYandexABFlags',
      setCities: 'city/setCities',
      getCities: 'city/getCities',
      setExpressDeliveryState: 'marketing/setExpressDeliveryState',
    }),
    sendLoggedInEvent () {
      this.$gtm.trackEvent({
        event: 'logged_in',
        profile_id: String(this.profile.id),
      })
    },
    sendBeforeUnloadEvent () {
      if (!this.isLoggedIn) {
        return
      }
      this.$gtm.trackEvent({
        event: 'before_unload',
        profile_id: String(this.profile.id),
      })
    },
    addBeforeUnloadEvent () {
      window.addEventListener('beforeunload', this.sendBeforeUnloadEvent)
    },
    async init () {
      if (this.$route.path.includes('dashboard') || this.$route.path.startsWith('/menu/')) {
        this.appLoaded = true
      }
      try {
        // TODO: выпилить маркетинговый костыль
        this.$store.dispatch('vcp/changeCurrentTarget', 'p5', { root: true })
        this.$store.dispatch('vcp/checkCurrentTarget', null, { root: true })
        // TODO: end - выпилить маркетинговый костыль
        await this.initializeTests({}, { global: true })
      } catch (error) {
        console.log('Init error: ', error)
      } finally {
        this.appLoaded = true
      }
    },
    async onChangeVcp (data) {
      console.log('onChangeVcp', data)
      this.isLoading = true
      try {
        await this.getVcpConfig(data)
        this.reInitPromotionsAndTests()
        this.isLoading = false
      } catch (error) {
        console.log('onChangeVcp error', error)
      } finally {
      }
    },
    sendSpeedMetrics () {
      if ('PerformanceObserver' in window && !this.perfomanceEventsSend) {
        new Promise((resolve, reject) => {
          const observer = new PerformanceObserver(list => {
            resolve(list)
          })

          observer.observe({
            entryTypes: ['paint'],
          })
        })
          .then(list => {
            list.getEntries().forEach(entry => {
              this.sendGTMMarkupEvent({
                block: 'meta',
                element: 'gf-v3-speed-metrics',
                action: entry.name,
                details: entry.startTime,
              })
              console.log(`${entry.name}: ${entry.startTime}`)
              this.perfomanceEventsSend = true
            })
          })
          .catch(error => {
            console.warn(error)
          })
        // largest contentfull paint
        // new PerformanceObserver(entryList => {
        //   console.log('lcc', entryList.getEntries())
        // }).observe({ type: 'largest-contentful-paint', buffered: true })
        // можно потом попробовать померить время на обработку первой интеракции
        // new PerformanceObserver(entryList => {
        //   for (const entry of entryList.getEntries()) {
        //     const delay = entry.processingStart - entry.startTime
        //     console.log('FID candidate:', delay, entry)
        //   }
        // }).observe({ type: 'first-input', buffered: true })
      }
    },
    reInitPromotionsAndTests () {
      if (this.appLoaded) {
        this.$store.dispatch('abtesting/initializeTests', {}, { global: true })
      }
    },
  },
}
</script>

<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
